import { API_URL, API_KEY, FILTER_SERVICE } from '../configs/global';

export const FETCH_SEARCH_SERVICE = 'FETCH_SEARCH_SERVICE';
export const CLEAR_SEARCH_SERVICE = 'CLEAR_SEARCH_SERVICE';

export const fetchSearchService = (service, excludeId, byservice) => {
  let url = `${API_URL}/autocomplete-v1/${service}?api_key=${API_KEY}${FILTER_SERVICE ? '&only_service_classes=' + FILTER_SERVICE : ''}`;
  if (excludeId) {
    url = `${API_URL}/autocomplete-v1/${service}?api_key=${API_KEY}&exclude_stop_ids=${excludeId}${FILTER_SERVICE ? '&only_service_classes=' + FILTER_SERVICE : ''}`;
  }

  return (dispatch) => {
    fetch(url)
      .then((response) => response.json())
      .then((response) =>
        dispatch({
          type: FETCH_SEARCH_SERVICE,
          payload: byservice ? response.matching_routes : response.matching_stops_by_relevance,
        })
      )
      .catch((error) => console.log(error));
  };
}

export const clearSearchService = (isClear) => (dispatch) =>
  dispatch({
    type: CLEAR_SEARCH_SERVICE,
  });



// WEBPACK FOOTER //
// ./src/actions/SearchServiceAction.js